<template>
  <default :vacancy-id="vacancyId" />
</template>

<script>
import Default from '@/routes_new/inner/vacancy/landing/default';

export default {
  name: 'VacancyLandingIndex',

  components: {
    Default
  },

  beforeRouteUpdate(to, from, next) {
    let c = true;

    if (this.has_changes) {
      c = confirm(this.$tr('vacancy.preferences.modals.leaveUnsavedData'));

      if (!c) {
        next(false);

        return false;
      }
    }
    next();
  },

  beforeRouteLeave(to, from, next) {
    let c = true;

    if (this.has_changes) {
      c = confirm(this.$tr('vacancy.preferences.modals.leaveUnsavedData'));

      if (!c) {
        next(false);

        return false;
      }
    }
    next();
  },

  props: ['vacancyId'],

  computed: {
    has_changes() {
      return this.$store.getters['vacancy/change'];
    }
  },

  created() {
    this.$emit('loaded', { key: 'set_current_page_id', v: 'landing' });
  }
};
</script>
